// src/services/api.ts
import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://switchr-admin-uat-api.digitalavenues.net';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Required for CORS when using cookies/auth headers
});

// Add token to all requests
apiClient.interceptors.request.use(
  (config) => {
    const token = Cookies.get('authToken');
    console.log('Token from cookies:', token ? 'Token exists' : 'No token found');
    console.log('Request:', config.method?.toUpperCase(), config.url);
    console.log('Request body:', config.data);
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Handle token expiration
apiClient.interceptors.response.use(
  (response) => {
    console.log('Response:', response.status, response.data);
    return response;
  },
  (error) => {
    console.error('Response error:', error.response?.status, error.response?.data);
    console.error('Full error:', error);
    
    if (error.response?.status === 401) {
      console.warn('⚠️ Unauthorized - clearing cookies and redirecting');
      Cookies.remove('authToken');
      Cookies.remove('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// API endpoints
export interface GetUserListParams {
  SearchText?: string;
  SortColumn?: string;
  SortDirection?: 'ASC' | 'DESC';
  Limit?: number;
  Offset?: number;
}

export const userAPI = {
  getUserList: async (params?: GetUserListParams) => {
    const body = {
      SearchText: params?.SearchText || "",
      SortColumn: params?.SortColumn || "Id",
      SortDirection: params?.SortDirection || "ASC",
      Limit: params?.Limit || 10,
      Offset: params?.Offset || 0,
    };
    
    console.log('Fetching users with params:', body);
    
    try {
      const response = await apiClient.post('/admin/getUserList', body);
      console.log('User list response:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('getUserList error:', error);
      throw error;
    }
  },
};

// Subscription API
export const subscriptionAPI = {
  getAllSubscriptions: async (stripeId: string,userId : number) => {
    try {
      const response = await apiClient.get('/admin/getAllSubscriptions', {
        params: {
          StripeId: stripeId,
          UserID : userId
        }
      });
      return response.data;
    } catch (error: any) {
      console.error('getAllSubscriptions error:', error);
      console.error('Error details:', error.response?.data);
      throw error;
    }
  },
};


export default apiClient;